export default __webpack_public_path__ + "static/media/ErrorIcon.80846350.png";